import { FUZE_RX_ICON_MAP, fuzeRxIconColorVariants } from '@alto/design-library-tokens';
import React from 'react';
import { MaterialSymbolIcon, type MaterialSymbolIconBrandProps } from './MaterialSymbolIcon.web';

export const FuzeRxIcon = (props: MaterialSymbolIconBrandProps) => {
  return (
    <MaterialSymbolIcon
      {...props}
      colorVariants={fuzeRxIconColorVariants}
      iconMap={FUZE_RX_ICON_MAP}
    />
  );
};
